/**
 * @generated SignedSource<<d56f1765cc23fb7aa3034deac1d40157>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminMembersReportCustomProfileFieldsTableQuery$variables = {
  after?: string | null;
  before?: string | null;
  first?: number | null;
  id: string;
  isPrivate?: boolean | null;
  last?: number | null;
  organizationMembershipId: string;
};
export type AdminMembersReportCustomProfileFieldsTableQuery$data = {
  readonly node: {
    readonly id?: string;
    readonly " $fragmentSpreads": FragmentRefs<"AdminMembersReportCustomProfileFieldsTable_PaginationFragment">;
  } | null;
};
export type AdminMembersReportCustomProfileFieldsTableQuery = {
  response: AdminMembersReportCustomProfileFieldsTableQuery$data;
  variables: AdminMembersReportCustomProfileFieldsTableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPrivate"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationMembershipId"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v10 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v11 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v12 = {
  "kind": "Variable",
  "name": "isPrivate",
  "variableName": "isPrivate"
},
v13 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v14 = {
  "kind": "Variable",
  "name": "organizationMembershipId",
  "variableName": "organizationMembershipId"
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v16 = [
  (v9/*: any*/),
  (v10/*: any*/),
  {
    "kind": "Literal",
    "name": "defaultTypesToExclude",
    "value": [
      "public_groups"
    ]
  },
  (v11/*: any*/),
  {
    "kind": "Literal",
    "name": "isDefault",
    "value": false
  },
  (v12/*: any*/),
  (v13/*: any*/),
  {
    "kind": "Literal",
    "name": "status",
    "value": "visible"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMembersReportCustomProfileFieldsTableQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v8/*: any*/),
              {
                "args": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "AdminMembersReportCustomProfileFieldsTable_PaginationFragment"
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "AdminMembersReportCustomProfileFieldsTableQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v16/*: any*/),
                "concreteType": "ProfileFieldNodeConnection",
                "kind": "LinkedField",
                "name": "profileFields",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileFieldNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileField",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WebFormQuestion",
                            "kind": "LinkedField",
                            "name": "webFormQuestion",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "type",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "richEditorBody",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WebFormQuestionOption",
                                "kind": "LinkedField",
                                "name": "options",
                                "plural": true,
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "label",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": [
                                  (v14/*: any*/)
                                ],
                                "concreteType": "WebFormAnswer",
                                "kind": "LinkedField",
                                "name": "answer",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isSkipped",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "body",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "selectedOptions",
                                    "storageKey": null
                                  },
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v15/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfoObjectType",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v16/*: any*/),
                "filters": [
                  "status",
                  "defaultTypesToExclude",
                  "isDefault",
                  "isPrivate"
                ],
                "handle": "connection",
                "key": "AdminMembersReportCustomProfileFieldsTable_profileFields",
                "kind": "LinkedHandle",
                "name": "profileFields"
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "91ab6413ad554d0c37ff4246566f63be",
    "id": null,
    "metadata": {},
    "name": "AdminMembersReportCustomProfileFieldsTableQuery",
    "operationKind": "query",
    "text": "query AdminMembersReportCustomProfileFieldsTableQuery(\n  $id: ID!\n  $first: Int\n  $after: String\n  $last: Int\n  $before: String\n  $organizationMembershipId: ID!\n  $isPrivate: Boolean\n) {\n  node(id: $id) {\n    __typename\n    ... on Organization {\n      id\n      ...AdminMembersReportCustomProfileFieldsTable_PaginationFragment_4pmZ8v\n    }\n    id\n  }\n}\n\nfragment AdminMembersReportCustomProfileFieldsTableRowFragment_tFaY3 on ProfileField {\n  title\n  webFormQuestion {\n    ...WebFormQuestionTypeTableFieldFragment\n    ...WebFormQuestionTableFieldFragment\n    ...WebFormQuestionResponseTableFieldFragment_tFaY3\n    id\n  }\n}\n\nfragment AdminMembersReportCustomProfileFieldsTable_PaginationFragment_4pmZ8v on Organization {\n  id\n  profileFields(first: $first, after: $after, last: $last, before: $before, status: visible, defaultTypesToExclude: [public_groups], isDefault: false, isPrivate: $isPrivate) {\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        ...AdminMembersReportCustomProfileFieldsTableRowFragment_tFaY3\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      startCursor\n      hasNextPage\n      hasPreviousPage\n    }\n  }\n}\n\nfragment WebFormQuestionResponseTableFieldFragment_tFaY3 on WebFormQuestion {\n  type\n  options {\n    id\n    label\n  }\n  answer(organizationMembershipId: $organizationMembershipId) {\n    isSkipped\n    body\n    selectedOptions\n    id\n  }\n}\n\nfragment WebFormQuestionTableFieldFragment on WebFormQuestion {\n  richEditorBody\n}\n\nfragment WebFormQuestionTypeTableFieldFragment on WebFormQuestion {\n  type\n  richEditorBody\n  options {\n    id\n    label\n  }\n}\n"
  }
};
})();

(node as any).hash = "f75ea98e778453a0beab53ccef2f115c";

export default node;
